import React from 'react'
import styled from 'styled-components'
import Text from 'ui/acro/typography/Text'
import { Flex } from 'ui/chandra'
import SortableList from '../../sortableList/SortableList'
import { getTotalNumberOfFilters } from './classFinderHelperMethods'

const FlexContainer = styled(Flex)`
  padding: 16px 0;
  align-items: center;
  gap: 24px;
  margin: 16px 60px;
`
const FirstContainer = styled(Flex)`
  justify-content: space-between;
  flex: 1;
`
const SecondContainer = styled(Flex)`
  justify-content: space-between;
  flex: 4;
`

const FilterSection = styled(Text)`
  color: #000;
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.352px;
`
const ClearAllSection = styled('div')`
  color: #000;
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%; /* 16.1px */
  text-decoration-line: underline;
  align-self: center;
  cursor: pointer;
`
const ClassesSection = styled('div')`
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.352px;
  align-self: center;
`
const SortSection = styled('div')`
  align-self: flex-end;
`

export default function ClassFinderNewSortAndClear({
  filteredItemLabels,
  onClearAll,
  totalProducts,
  order,
  onSort,
  contentLabel = 'Classes',
  sortableFields
}) {
  let numberOfActiveFilters = getTotalNumberOfFilters(filteredItemLabels)

  return (
    <FlexContainer className='SortAndClearTopSection'>
      <FirstContainer>
        <FilterSection>
          {numberOfActiveFilters >= 0
            ? `Filters (${numberOfActiveFilters})`
            : 'Filters'}
        </FilterSection>
        <ClearAllSection onClick={() => onClearAll()}>
          Clear All
        </ClearAllSection>
      </FirstContainer>
      <SecondContainer>
        <ClassesSection>
          {typeof totalProducts === 'number' && !Number.isNaN(totalProducts)
            ? totalProducts
            : 0}
          {totalProducts === 1
            ? contentLabel === 'Classes'
              ? ' Class'
              : ' Program'
            : ` ${contentLabel}`}
        </ClassesSection>
        <SortSection>
          <SortableList
            sortableFields={
              sortableFields || [
                'relevance',
                'rank',
                'az',
                'date',
                'durationShortToLong',
                'durationLongToShort'
              ]
            }
            order={order}
            onSort={onSort}
            alignLeftXs={true}
            sortLocation={'Classes'.toLowerCase()}
          />
        </SortSection>
      </SecondContainer>
    </FlexContainer>
  )
}
